import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const _23mpIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"23mp"} ref={ref}/>
});

_23mpIcon.displayName = "_23mpIcon";
